/* eslint-disable */
import { login, logout, getInfo } from '@/api/auth';
import { getToken, setToken, removeToken } from '@/utils/auth';
import router, { resetRouter } from '@/router';
import store from '@/store';

const state = {
  id: null,
  token: getToken(),
  name: '',
  email: '',
  prenom: '',
  avatar: '',
  roles: [],
  permissions: [],
  isadmin: false,
  panier: null
};

const mutations = {
  SET_ID: (state, id) => {
    state.id = id;
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_PRENOM: (state, prenom) => {
    state.prenom = prenom;
  },
  SET_EMAIL: (state, email) => {
    state.email = email;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions;
  },
  SET_ISADMIN: (state, isadmin) => {
    state.isadmin = isadmin;
  },
  SET_PANIER: (state, panier) => {
    state.panier = panier;
  },
};

const actions = {
    setPanier({ commit }, panier) {
        commit('SET_PANIER', panier);
    },
  // user login
  login({ commit }, userInfo) {
    const { email, password } = userInfo;
    console.log('n1.user.login' + email + password);
    return new Promise((resolve, reject) => {
      login({ email: email.trim(), password: password })
        .then(response => {
            if(response.meta && response.meta.access_token){
                console.log('n3.tokken' + response.meta.access_token);
                console.log('n3b.response' + JSON.stringify(response));
                commit('SET_TOKEN', response.meta.access_token);
                setToken(response.meta.access_token);
                resolve();
            }else{
                console.log('n3c.error ');
               reject();
            }
        })
        .catch(error => {
           console.log('n3.error ');
           console.log(error);
          reject(error);
        });
    });
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token)
        .then(response => {
          console.log('p1.response' + JSON.stringify(response));
          const { data } = response;

          if (!data) {
            reject("Nous n'avons pu vous identifier.");
          }

          const { roles, name, prenom, email, avatar, permissions, id } = data;
          // roles must be a non-empty array
          if (!roles || roles.length <= 0) {
            reject("Vous n'êtes pas allocataire");
          }

          commit('SET_ROLES', roles);
          if (roles.includes('admin')){
            commit('SET_ISADMIN', true);
          }
          commit('SET_PERMISSIONS', permissions);
          commit('SET_NAME', name);
          commit('SET_PRENOM', prenom);
          commit('SET_EMAIL', email);
          commit('SET_AVATAR', avatar);
          commit('SET_ID', id);
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      console.log('out1.user.logout');
      logout(state.token)
        .then(() => {
          console.log('out3.user.logout');
          commit('SET_TOKEN', '');
          commit('SET_ROLES', []);
          removeToken();
          resetRouter();
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      removeToken();
      resolve();
    });
  },

  // Dynamically modify permissions
  changeRoles({ commit, dispatch }, role) {
    return new Promise(async resolve => {
      // const token = role + '-token';

      // commit('SET_TOKEN', token);
      // setToken(token);

      // const { roles } = await dispatch('getInfo');

      const roles = [role.name];
      const permissions = role.permissions.map(permission => permission.name);
      commit('SET_ROLES', roles);
      commit('SET_PERMISSIONS', permissions);
      resetRouter();

      // generate accessible routes map based on roles
      const accessRoutes = await store.dispatch('permission/generateRoutes', { roles, permissions });

      // dynamically add accessible routes
      router.addRoutes(accessRoutes);

      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
